import * as yup from 'yup';
import { error } from '../text';

export const mylistValidationSchema = yup.object().shape({
  id: yup.number().nullable(),
  title: yup.string().required(error.required).max(250, error.below250),
  remarks1: yup.string().nullable().max(250, error.below250),
  remarks2: yup.string().nullable().max(250, error.below250)
});
